import axios from "axios";
import store from "@/store";
import router from "@/router";
import { MessageBox } from "element-ui";

axios.defaults.baseURL = "/hallportal";
axios.defaults.withCredentials = true;
// http request 拦截器
axios.interceptors.request.use(
  config => {
    if (store.getters.access_token) {
      config.headers.Authorization = `Bearer ${store.getters.access_token}`;
      config.headers.method = config.method;
      config.method =
        config.method == "put"
          ? "post"
          : config.method == "delete"
          ? "post"
          : config.method;
      config.headers.Request_Source = "pc";
      //可视化需要
      window.sessionStorage.setItem(
        "nz_access_token",
        `Bearer ${store.getters.access_token}`
      );
    } else {
      config.headers = {
        Accept: "application/json, text/plain, */*",
        "Request-Source": "pc",
        ...config.headers,
      };
    }
    return config;
  },
  err => {
    return Promise.reject(err);
  }
);

// http response 拦截器
axios.interceptors.response.use(
  response => {
    return response;
  },
  error => {
    if (router.currentRoute.name === "cassso" && error.response.status == 401) {
      return error.response;
    } else if (error.response) {
      const status = Number(error.response.status) || 200;
      const message = error.response.data.msg;
      if (router.currentRoute.name !== "login" && status === 401) {
        store.commit("SET_ACCESS_TOKEN", null);
        store.commit("SET_PERMISSIONS", []);
        // sessionStorage.removeItem("nz_access_token");
        router.replace("/login");
        return;
      }
      if (status === 500 || status === 503) {
        MessageBox.alert("服务器异常", "系统消息", {
          confirmButtonText: "确定",
          type: "warning",
          callback: action => {},
        });
        return error.response.data;
      }
    }
    return Promise.reject((error.response && error.response.data) || error);
  }
);

export default axios;
